import { FieldErrorProps } from '@rjsf/utils';
import { Templates } from '@rjsf/bootstrap-4';
import { MarkdownContent } from '../markdown-content';

export function FieldErrorTemplate({ errors, ...props }: FieldErrorProps) {
  return (
    /* @ts-ignore */
    <Templates.FieldErrorTemplate
      {...props}
      errors={errors?.map((error, index) => (
        <MarkdownContent key={`${error}-${index}`}>
          {error as string}
        </MarkdownContent>
      ))}
    />
  );
}
